var n = (o, s, i) => new Promise((r, e) => {
  var f = (t) => {
    try {
      a(i.next(t));
    } catch (c) {
      e(c);
    }
  }, m = (t) => {
    try {
      a(i.throw(t));
    } catch (c) {
      e(c);
    }
  }, a = (t) => t.done ? r(t.value) : Promise.resolve(t.value).then(f, m);
  a((i = i.apply(o, s)).next());
});
import { selfAxios as d } from "@oppein/op-utils";
function u(o) {
  return n(this, null, function* () {
    const {
      data: s
    } = yield d.get(
      "/commoditycenter/productClassification/list",
      { params: o }
    );
    return s;
  });
}
export {
  u as getList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/commoditycenter/productClassification/list/get.js
// module id = 1803
// module chunks = 67